export enum EnvironmentType {
  DEV = 'dev',
  QA = 'qa',
  STAGE = 'stage',
  PROD = 'prod',
  DEMO = 'demo',
}
